import { render, staticRenderFns } from "./ChooseOracle.vue?vue&type=template&id=0a1fad47&"
import script from "./ChooseOracle.vue?vue&type=script&lang=js&"
export * from "./ChooseOracle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChooseOracle.vue"
export default component.exports